// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"TradeNav_clearfix_3Wd1N"};